<!-- @format -->

<div
	id="pdp-return-policy"
	class="hmf-pb-s bottom-border hmf-mb-s hmf-mx-s hmf-mx-m-0 hmf-mt-s hmf-my-m-0 hmf-py-m-m hmf-mb-m-m return-text-color hmf-body-s">
	{{ returnPolicyMessage().returnPolicyContent }}
	<a
		hmf-text-link
		id="return-link"
		classList="return-link"
		dataEm="PDP-ReturnPolicy"
		[linkURL]="returnPolicyMessage().returnPolicyUrl">
		<homefield-icon
			height="16px"
			width="16px"
			name="alert-info-outlined"
			fill="var(--hmf-label-secondary-subtle-static)">
		</homefield-icon>
	</a>
</div>
